import { setToken, getToken ,clearTenantId ,clearLocalCache} from '@/libs/util'
import api from '@/api'

// 并发去重：多个页面同时触发时共用同一个请求
let ensureUserInfoPromise = null

export default {
  state: {

    //保存用户信息
    userInfo: JSON.parse(window.sessionStorage.getItem('USER-INFO')) || {},
    token: getToken(),
  },
  mutations: {

    //修改用户信息
    muChnageUserInfo(state,targetData){
      state.userInfo = targetData;
      window.sessionStorage.setItem('USER-INFO', JSON.stringify(targetData));
    },

    //用户登录标识
    setToken (state, token) {
      state.token = token
      setToken(token)
    },

    //用户退出登录
    logOut (state) {
      setToken("")
      clearTenantId();
      clearLocalCache()
      // 重置用户信息，避免会话失效后残留脏数据导致 userId 为 undefined
      state.userInfo = {}
      window.sessionStorage.removeItem('USER-INFO')
    }

  },

  actions: {
    // 确保用户信息与菜单已加载：以当前 token 为唯一数据源。
    // 该接口同时返回 loginUser 与 menu，这里一次请求填充两者，避免重复请求。
    // 新标签页/刷新时 sessionStorage 里可能没有 USER-INFO，此处用 token 补拉一次。
    // vm 为可选的组件实例，透传给 api 以便 token 失效(401)时统一跳登录。
    ensureUserInfo ({ state, rootState, commit }, vm) {
      const hasUser = !!(state.userInfo && state.userInfo.userId)
      const hasMenu = !!(rootState.app.sysMenulist && rootState.app.sysMenulist.length)
      if (hasUser && hasMenu) {
        return Promise.resolve(state.userInfo)
      }
      if (!getToken()) {
        return Promise.resolve(null)
      }
      if (ensureUserInfoPromise) return ensureUserInfoPromise
      ensureUserInfoPromise = api.getData('system-server/user/get/home/date', vm).then((res) => {
        ensureUserInfoPromise = null
        if (res && res.state === 1 && res.data) {
          if (res.data.menu) {
            commit('updateMenulist', res.data.menu)
          }
          if (res.data.loginUser && res.data.loginUser.userId) {
            commit('muChnageUserInfo', res.data.loginUser)
            return res.data.loginUser
          }
        }
        return null
      }).catch(() => {
        ensureUserInfoPromise = null
        return null
      })
      return ensureUserInfoPromise
    }
  }

}
